import { createBrowserRouter } from "react-router-dom";

import Auth from "./pages/Admin/Auth/Auth";
import Dashboard from "./pages/Admin/Dashboard/Dashboard";
import MasterLayout from "./pages/Admin/Layouts/MasterLayout";
import CreateUser from "./pages/Admin/user/CreateUser";
import MultiStepWithSidebarBootstrap from "./pages/Admin/Dashboard/Dashboard";

//user pages
import ToolLandingPage from "./pages/user/ToolLandingPage";
import Assessments from "./components/Assessments";
import AssessmentForm from "./components/AssessmentForm";
import Result from "./pages/user/Result";
import AssessmentLandingPage from "./pages/user/AssessmentLandingPage";
import QuestionWizard from "./components/QuestionWizard";
import Error404 from "./pages/user/Error404";

import PrivateRoutes from "./protected/PrivateRoutes";
import PublicRoute from "./protected/PublicRoute";
import Export from "./pages/Admin/pages/Export";
import { elements } from "chart.js";

const routes = [
  {
    path: "/",
    // element: <Auth />,
    element: <AssessmentForm />,
  },

  {
    path: "/login/admin",
    element: <Auth />,
  },
  {
    path: "/admin",
    element: (
      <PrivateRoutes>
        <MasterLayout username="Jayant" />
      </PrivateRoutes>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      { path: "create", element: <CreateUser /> },

      // ✅ Master Content pages
      {
        path: "principals",
        element: <MultiStepWithSidebarBootstrap startAt={0} />,
      },
      {
        path: "categories",
        element: <MultiStepWithSidebarBootstrap startAt={1} />,
      },
      {
        path: "metrics",
        element: <MultiStepWithSidebarBootstrap startAt={2} />,
      },
      {
        path: "indicators",
        element: <MultiStepWithSidebarBootstrap startAt={3} />,
      },
      { path: "export", element: <Export /> },
    ],
  },

  {
    path: "/user",
    element: <ToolLandingPage />,
    children: [
      // {
      //   path: "landing-page",
      //   element: <Assessments />,
      // },
      // {
      //   path: "login-page",
      //   element: <AssessmentForm />,
      // },
      {
        path: "assessment-landing-page",

        element: (
          <PrivateRoutes userRoute={true}>
            <AssessmentLandingPage />
          </PrivateRoutes>
        ),
      },
      {
        path: "question-page",
        element: (
          <PrivateRoutes userRoute={true}>
            <QuestionWizard />
          </PrivateRoutes>
        ),
      },
      {
        path: "result",
        element: (
          <PrivateRoutes userRoute={true}>
            <Result />
          </PrivateRoutes>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <Error404 />,
  },
];

export default routes;
